<template>
  <Bar :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId" :dataset-id-key="datasetIdKey"
    :css-classes="cssClasses" :styles="styles" :width="width" :height="height" />
</template>
<script>
import { Bar } from 'vue-chartjs/legacy'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
export default {
  name: 'BarChart',
  components: {
    Bar
  },
  props: {
    labels: {
      type: Array,
      default: () => ["2023-12-15", "2023-12-14", "2023-12-13", "2023-12-12", "2023-12-11"]
    },
    labelData: {
      type: Array,
      default: () => [0, 0, 0, 0, 0]
    },
    chartId: {
      type: String,
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    width: {
      type: Number,
      default: 400
    },
    height: {
      type: Number,
      default: 400
    },
    cssClasses: {
      default: '',
      type: String
    },
    styles: {
      type: Object,
      default: () => { }
    },
    plugins: {
      type: Array,
      default: () => []
    },
    chartData: {
      type: Object,
      default: () => { }
    },
  },
  data() {
    return {
      legend: {
        display: false
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false
      },
    }
  },
}
</script>